/**
 * @render react
 * @name NextSteps
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import { Icon } from 'Components/atoms/Icon';
import { Heading } from 'Components/molecules/Heading';
import { Link } from 'Components/molecules/Link';

import './_style.scss';

/**
 * NextSteps component
 *
 * @param {Object} props - the props object
 * @param {string} props.title - The title of the section
 * @param {Object[]} props.urls - Array of urls containing url, icon, title and rel
 *        @param {string} urls.url - URL to be passed to link href attribute
 *        @param {string} urls.icon - icon for the button link
 *        @param {string} urls.title - title of the link/button
 *        @param {string} urls.rel - rel attribute of the link
 * @param {Object} props.extraClassNames - Extra classes to be added to the component
 * @param {Object} props.context - Extra information coming from Polaris provider
 * @param {boolean} props.loadStyles - Whether to apply the class names for styling
 */
const NextSteps = ({
  title, urls, loadStyles, context: { cssPrefix }, extraClassNames,
}) => (
  urls.length !== 0 && (
    <div
      className={classNames({
        [`${cssPrefix}__next-steps`]: loadStyles,
        ...extraClassNames,
      })}
    >
      {title && <Heading size={6}>{title}</Heading>}
      <div className={`${cssPrefix}__next-steps--urls`}>
        {urls.map((item, index) => (
          item.url
          && (
            <Link
              rel={item.rel || 'nofollow'}
              href={item.url}
              key={index}
              onClick={item.onClick || undefined}
            >
              {item.icon && <Icon icon={item.icon} />}
              {item.title}
            </Link>
          )))}
      </div>
    </div>
  )
);

/**
 * Valid props
 */
NextSteps.propTypes = {
  title: PropTypes.string,
  urls: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      icon: PropTypes.string,
      title: PropTypes.string,
      rel: PropTypes.string,
    }),
  ),
  context: PropTypes.shape(),
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
};

/**
 * Default props
 */
NextSteps.defaultProps = {
  title: 'Next Steps',
  urls: [],
  context: {},
  loadStyles: true,
  extraClassNames: {},
};

export default withPolaris(NextSteps);
